/**
 * Comma-grouped for display, always `en-US` regardless of the viewer's
 * browser locale - so screenshots/demos read consistently no matter who
 * takes them. Falls back to 0 for anything that isn't a finite number:
 * `undefined`, `null`, an unparsable string, or an upstream `NaN` that
 * would otherwise render literally as the text "NaN".
 */
export const formatCount = (
  value: number | string | null | undefined,
): string => {
  const numeric = typeof value === 'number' ? value : Number(value);
  const safe = Number.isFinite(numeric) ? numeric : 0;
  return safe.toLocaleString('en-US');
};

/** `TablePagination`'s `labelDisplayedRows` formatter, comma-grouped. */
export const formatDisplayedRows = ({
  from,
  to,
  count,
}: {
  from: number;
  to: number;
  count: number;
}): string =>
  `${formatCount(from)}–${formatCount(to)} of ${
    count !== -1 ? formatCount(count) : `more than ${formatCount(to)}`
  }`;
